import React, { useState, useEffect } from "react";
import "./styles.css";
import "./styles/Login.css";
import ScheduleBuilder from "./ScheduleBuilder";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { logout, isAuthenticated } from "./services/authService";

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    if (isAuthenticated()) {
      setAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleLoginSuccess = (user) => {
    setAuthenticated(true);
  };

  const handleLogout = () => {
    logout();
    setAuthenticated(false);
  };

  if (loading) {
    return <div style={{ textAlign: "center", padding: "50px" }}>Loading...</div>;
  }

  if (!authenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <ProtectedRoute isAuthenticated={authenticated} onLogout={handleLogout}>
      <div className="App">
        <ScheduleBuilder />
      </div>
    </ProtectedRoute>
  );
}

export default App;
